export const ERROR_TYPE = {
  SNAG_UI_ERROR: 'snag-ui-error',
};

export const ERROR_CATEGORY = {
  FE: 'FE',
};

export const UNAUTHORIZED_ERROR = 'Unauthorized';
export const UNAUTHORIZED_ERROR_CODE = 401;

export const DEFAULT_META_DATA = {
  errorSource: ERROR_TYPE.SNAG_UI_ERROR,
};

export const MINDTICKLE_DOMAIN = 'mindtickle.com';

export const EXCEPTION_URLS = [
  { type: 'host', value: 'callai' },
  { type: 'host', value: 'cf-' },
  { type: 'host', value: 'dsr-' },
  { type: 'pathname', value: 'ping' },
  { type: 'host', value: 'cnt-svc-uppy-cmpnin' },
];

export const EPOCH_TIME_PARAM = 'MTEpochTime';

export const RE_LOGIN_REDIRECT_URL = 'ReLoginRedirectUrl';
